import Grid, {GridProps} from '@mui/material/Grid';
import React, {memo} from 'react';

const MUIGrid = (props: GridProps): any => {
    const {children, xs, sm, md, lg, container, item, ...rest} = props;

    return (
        <Grid xs={xs} sm={sm} md={md} lg={lg} container={container} item={item} {...rest}>
            {children}
        </Grid>
    );
};

export default memo(MUIGrid);
